import { AliasToken } from 'antd/es/theme/internal';
import { responsiveStyle } from '../../../../../util/helpers';
import { windowBreakpoints } from '../../../../../hooks/useDeviceSize';

export const accountSwitcherStyle = (breakpoints: windowBreakpoints, token?: AliasToken) =>
  responsiveStyle(breakpoints, {
    noMargin: { margin: 0 },
    checkboxB: {
      fontSize: '14px',
      fontWeight: 300,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    typesHeader: { width: '100%', marginBottom: '12px' },
    captchaText: { opacity: 0.5, fontSize: '12px', letterSpacing: '-0.25px' },
    formItem: { margin: 0, marginBottom: '12px' },
    formItemCheck: { margin: 0, marginBottom: '14px', fontWeight: 300 },
    formLabel: { color: '#0A0A0AA6', fontWeight: 400 },
    linkBox: { fontSize: '14px', fontWeight: 300 },
    nextButton: { width: '100%', backgroundColor: '#444B90', color: 'white', marginBottom: '6px' },
    solidDivider: {
      marginTop: '0px',
      marginBottom: '0px',
      borderTop: '1px solid #D9D9D9',
    },
    createAccountTypeButton: {
      transition: 'all 0.3s ease',
      width: '100%',
      fontSize: '16px',
      padding: '20px',
    },
    createAccountTypeButtonSelected: {
      transition: 'all 0.3s ease',
      width: '100%',
      fontSize: '16px',
      padding: '20px',
      backgroundColor: '#444B9022',
      boxShadow: '0px 0px 0px 2px #444B90dd inset',
      color: '#444B90',
      fontWeight: '500',
    },
    selectionBox: {
      backgroundColor: '#FCFCFF',
      border: '1px solid #D9D9D9',
      height: '48px',
      borderRadius: '8px',
      padding: '12px 16px 12px 16px',
      cursor: 'pointer',
    },
    selectionBoxJumbo: {
      backgroundColor: '#FCFCFF',
      border: '1px solid #D9D9D9',
      height: '84px',
      borderRadius: '8px',
      padding: '12px 16px 12px 16px',
      cursor: 'pointer',
    },
    mainTag: {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '0px',
    },
    secondaryTag: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '0px',
      opacity: '0.65',
    },
    inlineLink: {
      color: '#1890FF',
      cursor: 'pointer',
      fontSize: '16px',
      display: 'inline',
      fontWeight: '400',
    },
    createText: {
      fontSize: '16px',
      fontWeight: '400',
      textAlign: 'start',
      width: '100%',
    },
  });
